import { useSnackbar } from "@powerdiary/components-library/lib";
import { AxiosError } from "axios";
import { useClientPortalConfigContext } from "../../../context";
import { WaitlistRequestSubmitModel } from "../../../types/generated/models";
import { usePostMutation } from "../../../hooks/useClientPortalQuery";

export function useSubmitWaitlistRequest() {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { enqueueSnackbar } = useSnackbar();

    const { mutateAsync, isPending } = usePostMutation<string, AxiosError, WaitlistRequestSubmitModel>({
        url: `/api/v1/${clientPortalGuid}/Waitlist`,
    });

    const submitWaitlistRequest = async (data: WaitlistRequestSubmitModel, onSuccess: () => void) => {
        await mutateAsync(data);

        enqueueSnackbar("Waitlist request successfully submitted", { variant: "success" });
        onSuccess();
    };

    return {
        isPending,
        submitWaitlistRequest,
    };
}
